import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import CharacterBackground from 'ui/characters/CharacterBackground';
import { getColorType } from 'utils/types';

import s from './WithCharacterBackground.module.scss';

const cx = cn.bind(s);

const WithCharacterBackground = ({
  children, className, type = 'character', color, extra, transparent, position = 'top', ...attrs
}) => (
  <div className={cx(className, 'container', {
    alignTop: position === 'top' || position === 'fill',
    alignBottom: position === 'bottom',
    alignCenter: position === 'center',
    fill: position === 'fill',
  })} {...attrs}>
    <CharacterBackground color={color} transparent={transparent} className={cx('background')} />
    { extra && <div className={cx('extra')}>{extra}</div>}
    { children && <div className={s.characterContainer}>
      <div className={cx('character', { imageWrapper: type === 'image' })}>
        { children }
      </div>
    </div> }
  </div>
);

WithCharacterBackground.propTypes = {
  type: PropTypes.oneOf(['character', 'image']),
  color: getColorType(['grey', 'brown']),
  children: PropTypes.element,
  extra: PropTypes.element,
  position: PropTypes.oneOf(['bottom', 'top', 'fill', 'auto', 'center']),
};

export default WithCharacterBackground;
